import React from 'react';
import moment from 'moment';
import {makeStyles, Typography} from '@material-ui/core';
import {CSVLink} from "react-csv";
import {useIntl} from 'react-intl';
import customAxios from "../../API/customAxios";
import {headers, data} from './csvHeader'

const useStyles = makeStyles((theme) => ({
    csvLink: {
        color: 'white',
        '&:hover': {
            color: 'white',
        },
        display: 'contents'
    },
    button: {
        height: '2.8em',
        backgroundColor: '#2C3E50',
        '&:hover': {
            backgroundColor: '#080C0F',
        }
    }
}));

export default function ExportLeaveSummary({setIsActive, isShiftDuty}) {
    const classes = useStyles();
    const intl = useIntl();
    const [csvEmployeeRecord, setCsvEmployeeRecord] = React.useState([]);
    const [filename, setFilename] = React.useState('');
    const [getHeaders, setHeaders] = React.useState([]);
    const csvLink = React.useRef();

    function getData() {
        setIsActive(true);
        customAxios.get(`/export_leave_summary`)
            .then(res => {
                const csvData = res.data['results'];
                const currentDate = moment().format('YYYY_MM_DD');
                setHeaders(headers(intl, res.data['active_year'], isShiftDuty));
                setFilename('Employees_Leave_Summary_Report_' + currentDate + '.csv');
                const record = [];
                for (let i = 0; i < csvData.length; i++) {
                    record.push(data(csvData[i]));
                }
                setCsvEmployeeRecord(record);
                setIsActive(false);
                csvLink.current.link.click();
            })
    }

    return (
        <div>
            <Typography onClick={getData}
                        style={{color: '#000'}}>{intl.formatMessage({id: 'myteam.leave_summary'})}</Typography>
            <CSVLink filename={filename} data={csvEmployeeRecord} headers={getHeaders}
                     className={classes.csvLink}
                     ref={csvLink}/>
        </div>
    );
}
